import React, { useEffect, useState, useRef } from "react";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import { useTranslation } from "react-i18next";
import "../../../../Localization/i18n";
import i18n from "i18next";
import { useNavigate } from "react-router-dom";
import { Checkbox, Chip, ListItemText } from "@mui/material";
import Edit from "../../../../icons/edit.svg";
import Trash from "../../../../icons/trash1.svg";
import Eye from "../../../../icons/eye.svg";
import axios from "../../../../utils/fvAxios";
import { Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { ToastContainer, toast } from "react-toastify";
import apiinfo from "../../../../utils/base-uri.json";
import { HasScreenPermissions, getGlobalClientId } from "../../../../utils/Token";
import RolesAdminAccount from "./RolesAdminAccount";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Nodata from "../../../Nodata/Nodata";
import { HasPermissions } from '../../../../utils/Token';
import INFO from '../../../../pages/commom/RouteUrlInfo.json';
import PER from "../../../../utils/Enums.json";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.action.hover,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

export default function Roles() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const ITEM_HEIGHT = 50;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
        width: 200,
      },
    },
  };

  const toastNotify = (message, isSuccess = true) => {
    if (isSuccess) {
      toast.success(message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const menuListRef = useRef(null);

  const scrollToTopOfOtions = () => {
    setTimeout(() => {
      if (menuListRef.current) {
        const children = menuListRef.current.children;
        if (children.length >= 2) {
          const secondLastOption = children[children.length - 2];
          if (secondLastOption) {
            secondLastOption.scrollTop = 0;
          }
        }
      }
    }, 5);
  };

  const [getDetails, setDetails] = useState([]);
  const [orgTypes, setOrgTypes] = useState([]);
  const [orgType, setOrgType] = useState("Select Organization Type");
  const [RoleName, setRoleName] = useState("");
  const [Rank, setRank] = useState("");
  const [open, setOpen] = useState(false);
  const [PopBoxId, setPopBoxId] = useState("");
  const [RoleTextName, setRoleTextName] = useState("");
  const [RoleId, setRoleId] = useState("");
  const [Refresh, setRefresh] = useState(false);
  const [orgRoles, setOrgRoles] = React.useState([]);
  const [orgRoleId, setOrgRoleId] = React.useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);

  const handleClickOpen = (Val, Id, Text) => {
    const roleId = Val == 3 ? Id : null;
    setRoleId(Val != 1 ? Id : null);
    setRoleTextName(Val == 3 ? Text : null);
    setRank(Val == 2 ? Text : null);
    setOpen(true);
    setPopBoxId(Val);
    if (Val == 3) {
      axios
        .get(
          "RolesAndPermissions/GetOrganizationRoles?roleId=" +
          roleId +
          "&allRoles=true"
        )
        .then((res) => {
          if (res?.data?.responseCode === 100) {
            setOrgRoles(res?.data?.data?.orgRoles);
            setSelectAllChecked(res?.data?.data?.checkAll);
          } else {
            toastNotify(res?.data?.responseMessage, false);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleClose = () => {
    setOpen(false);
  };
  const CahngeRank = (r) => {
    if (r > -1) setRank(r);
  };

  useEffect(() => {
    setSpinner(!spinner);
    axios
      .get("RolesAndPermissions/GetSystemRoles")
      .then((res) => {
        setDetails(res?.data?.data);
        setSpinner(spinner);
      })
      .catch((err) => {
        console.log(err);
      });
    GetDetailsToAddUser();
  }, [Refresh]);

  const GetDetailsToAddUser = async () => {
    const response = await axios.get("SystemUser/GetDetailsToAddUser");
    if (response?.data?.data) {
      setOrgTypes(response?.data.data?.orgTypes);
    }
  };

  const AddRole = () => {
    if (PopBoxId == 1) {
      if (RoleName != "" && orgType != "Select Organization Type") {
        const NewRole = {
          roleName: RoleName,
          organizationType: orgType,
        };
        axios
          .post("RolesAndPermissions/AddSystemRole", NewRole)
          .then((res) => {
            if (res?.data?.responseCode == 100)
              toastNotify(res?.data?.responseMessage, true);
            setRefresh(!Refresh);
            handleClose();
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        toastNotify("Please Enter Mandatory Fields", false);
      }
    } else if (PopBoxId == 2) {
      if (Rank != "") {
        const NewRank = {
          orgRank: Rank,
          roleId: RoleId,
        };
        axios
          .post("RolesAndPermissions/UpdateOrgRank", NewRank)
          .then((res) => {
            if (res?.data?.responseCode == 100)
              toastNotify(res?.data?.responseMessage, true);
            setRefresh(!Refresh);
            handleClose();
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        toastNotify("Please Enter Mandatory Fields", false);
      }
    } else if (PopBoxId == 3) {
      const formData = new FormData();
      formData.append("roleId", RoleId);
      selectedOrgs?.forEach((org, index) => {
        formData.append(`orgIds[${index}]`, org);
      });
      axios
        .post("RolesAndPermissions/AssignOrgRoles", formData, {
          headers: { "Content-Type": "application/json" },
        })
        .then((res) => {
          if (res?.data?.responseCode == "100") {
            toastNotify(res?.data?.responseMessage, true);
            setRefresh(!Refresh);
            handleClose();
          } else {
            toastNotify(res?.data?.responseMessage, false);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => { });
    }
  };

  const [shows, setShow] = useState(true);
  const [MoveDetails, setMoveDetails] = useState({});
  const [Type, setType] = useState("");
  const [Trg, setTrg] = useState(false);

  const OpenTab = (val, r) => {
    setType(val);
    setMoveDetails(r);
    setShow(!shows);
    setTrg(!Trg);
  };
  const CloseTab = () => {
    setShow(!shows);
    setTrg(!Trg);
  };
  const [spinner, setSpinner] = React.useState(false);
  const SpinnerClose = () => {
    setSpinner(false);
  };

  const [selectedOrgs, setSelectedOrgs] = useState([]);
  const [defaultSelectedOrgs, SetDefaultSelectedOrgs] = useState([]);

  useEffect(() => {
    if (orgRoles) {
      let selectedOrgs = orgRoles
        .filter((x) => x.status == true)
        .map((y) => y?.orgId);
      SetDefaultSelectedOrgs([...selectedOrgs]);
      setSelectedOrgs([...selectedOrgs]);
    }
  }, [orgRoles]);

  const handleChange = (node) => {
    const currentSelected = node?.props?.value;
    setSelectedOrgs((prev) => {
      if (!prev.includes(currentSelected)) {
        return [...prev, currentSelected];
      } else {
        let index = prev.indexOf(currentSelected);
        prev.splice(index, 1);
        return [...prev];
      }
    });
  };

  const handleSelecteAll = (event) => {
    if (event?.target?.checked) {
      setSelectAllChecked(true);
      setSelectedOrgs(orgRoles?.map((doc) => doc?.orgId));
      scrollToTopOfOtions();
    } else {
      const formData = new FormData();
      formData.append("roleId", RoleId);
      selectedOrgs?.forEach((org, index) => {
        formData.append(`orgIds[${index}]`, org);
      });
      axios
        .get(
          "RolesAndPermissions/OrganizationRolesWithExistingData?roleId=" +
          RoleId
        )
        .then((res) => {
          if (res?.data?.responseCode == "100") {
            setSelectAllChecked(false);
            setOrgRoles(res?.data?.data?.orgRoles);
            scrollToTopOfOtions();
          } else {
            toastNotify(res?.data?.responseMessage, false);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => { });
    }
  };

  return (
    <>
      <ToastContainer />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={spinner}
        onClick={SpinnerClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Dialog
        maxWidth={"sm"}
        fullWidth={true}
        open={open}
        onClose={handleClose}
      >
        <DialogContent
          sx={{ padding: "40px 48px", overflowX: "hidden" }}
          className="pb-1"
        >
          <DialogTitle
            sx={{
              textAlign: "center",
              fontWeight: 500,
              fontSize: 20,
            }}
          >
            {PopBoxId == 1 ? (
              "Add  New Role"
            ) : (
              <div> {PopBoxId == 2 ? "Edit Rank" : RoleTextName}</div>
            )}
          </DialogTitle>
          {PopBoxId == 1 ? (
            <>
              <span
                style={{ color: "#3E4A62" }}
                className="username-label mx-2 mt-2"
              >
                System Role Name<span className="red-color">*</span>
              </span>
              <TextField
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                required
                type="text"
                id=" SystemRoleName"
                name="SystemRoleName"
                placeholder="System Role Name"
                size="small"
                className="form-control text-feild-custom mx-2"
                onChange={(e) => setRoleName(e.target.value)}
              />
              <span
                className="username-label mx-2 mt-1"
                style={{ color: "#3E4A62" }}
              >
                Role For <span className="red-color">*</span>
              </span>
              <Select
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                value={orgType}
                required
                size="small"
                placeholder="Role For"
                name="RoleFor"
                MenuProps={MenuProps}
                id="RoleFor"
                className="form-control text-feild-custom mx-2"
                onChange={(e) => setOrgType(e.target.value)}
              >
                {orgTypes?.map((r, index) => (
                  <MenuItem key={index} title={r.text} value={r?.text}>
                    {r.text}
                  </MenuItem>
                ))}
              </Select>
            </>
          ) : (
            <div>
              {PopBoxId == 2 ? (
                <>
                  <span
                    style={{ color: "#3E4A62" }}
                    className="username-label mx-2 mt-2"
                  >
                    Rank <span className="red-color">*</span>
                  </span>
                  <TextField
                    sx={{
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                    }}
                    required
                    type="number"
                    id="Rank"
                    name="Rank"
                    value={Rank || ""}
                    placeholder="Rank"
                    size="small"
                    className="form-control text-feild-custom mx-2"
                    onChange={(e) => CahngeRank(e.target.value)}
                  />
                </>
              ) : (
                <>
                  <Select
                    labelId="orgnizationRoles"
                    id="orgnizationRoles"
                    multiple
                    size="small"
                    sx={{ width: "500px", overflow: "hidden" }}
                    name="orgnizationRoles"
                    value={selectedOrgs || ""}
                    onChange={(e, node) => handleChange(node)}
                    MenuProps={{
                      ref: menuListRef,
                      PaperProps: MenuProps.PaperProps,
                    }}
                    renderValue={(selected) => (
                      <Box
                        sx={{ flexWrap: "wrap", gap: 0.5, overflowX: "hidden" }}
                      >
                        {selected?.map((value, i) => (
                          <Chip
                            sx={{ marginRight: "10px" }}
                            key={i}
                            label={
                              orgRoles.filter((x) => x.orgId == value)[0]
                                ?.orgName
                            }
                          />
                        ))}
                      </Box>
                    )}
                    inputProps={{ "aria-label": "Select Organizations" }}
                  >
                    <MenuItem key="Select All">
                      <Checkbox
                        id="select-all-checkbox"
                        indeterminate={
                          selectedOrgs?.length > 0 &&
                          selectedOrgs?.length < orgRoles?.length
                        }
                        checked={selectAllChecked}
                        onChange={(event) => {
                          handleSelecteAll(event);
                        }}
                      />
                      <label
                        htmlFor="select-all-checkbox"
                        style={{
                          fontSize: "16px",
                          fontWeight: "500",
                          color: "rgba(0, 0, 0, 0.87)",
                          width: "320px",
                          cursor: "pointer",
                        }}
                      >
                        Select All
                      </label>
                    </MenuItem>
                    {orgRoles?.map((doc) => (
                      <MenuItem
                        key={doc?.orgId}
                        value={doc?.orgId}
                        title={doc?.orgName}
                        disabled={doc?.isDisable || selectAllChecked}
                      >
                        <Checkbox
                          checked={selectedOrgs.includes(doc?.orgId)}
                          disabled={doc?.isDisable}
                        />
                        <ListItemText
                          primary={doc?.orgName}
                          sx={{ overflowX: "hidden" }}
                          disabled={doc?.isDisable}
                        />
                      </MenuItem>
                    ))}
                  </Select>

                  {/* <Select
                                labelId="docs-label"
                                id="docs-select"
                                multiple
                                size='small'
                                sx={{
                                    '& legend': { display: 'none' },
                                    '& fieldset': { top: 0 },
                                    width: "450px",
                                    marginLeft: "10px"
                                }}
                                name="Site Safety Representive"
                                value={orgRoleId || []}
                                MenuProps={MenuProps}
                                renderValue={(selected) =>
                                    selected
                                        .map((value) => orgRoles?.find((doc) => doc?.orgId === value)?.orgName)
                                        .filter((text) => text !== undefined)
                                        .join(", ")
                                }
                                onChange={(e) => setOrgRoleId(e.target.value)}
                            >
                                <MenuItem key="Select All" hidden={orgRoles?.length < 0}>
                                    <Checkbox
                                        indeterminate={
                                            orgRoleId?.length > 0 && orgRoleId?.length < orgRoles?.length
                                        }
                                        checked={orgRoleId?.length === orgRoles?.length}
                                        onChange={(event) => {
                                            if (event?.target?.checked) {
                                                setOrgRoleId(orgRoles?.map((doc) => doc?.orgId));
                                                scrollToTopOfOtions()
                                            } else {
                                                setOrgRoleId([]);
                                            }
                                        }}

                                    />
                                    <label htmlFor="select-all-checkbox" style={{ fontSize: "16px", fontWeight: "500", color: "rgba(0, 0, 0, 0.87)", width: "320px", cursor: "pointer" }}>
                                        Select All
                                    </label>

                                </MenuItem>
                                {orgRoles?.map((r, i) => (
                                    <MenuItem key={i} value={r?.orgId}>
                                        <Checkbox checked={orgRoleId?.indexOf(r?.orgId) > -1} />
                                        <ListItemText primary={r?.orgName} />

                                    </MenuItem>
                                ))}
                            </Select> */}
                  {/* <Select
                                sx={{
                                    "& legend": { display: "none" },
                                    "& fieldset": { top: 0 },
                                }}
                                className="form-control text-feild-custom mx-2"
                                required
                                id="Org"
                                name="Org"
                                placeholder="Org"
                                MenuProps={MenuProps}
                                size="small"
                                value={orgRoleId || ""}
                                onChange={(e) => setOrgRoleId(e.target.value)}
                            >
                                {orgRoles?.map((item, index) => (
                                    <MenuItem key={index} title={item?.orgName} value={item?.orgId}>
                                        {item?.orgName}
                                    </MenuItem>
                                ))}
                            </Select> */}
                </>
              )}
            </div>
          )}
        </DialogContent>

        <DialogActions className="pb-5">
          <div className="login-help__buttonContainer d-flex gap-2 align-items-center px-5">
            <Button
              variant="contained"
              className="login-help-button-cancel mx-2"
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              className="login-button-request mx-2"
              onClick={AddRole}
            >
              Save
            </Button>
          </div>
        </DialogActions>
      </Dialog>

      <div style={{ display: shows ? "block" : "none" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            padding: "20px",
            "& hr": { mx: 0.5 },
          }}
        >
          <h4 style={{ marginRight: "auto", marginLeft: "-18px" }}>
            {t("Roles.systemroles")}
          </h4>
          {HasPermissions(INFO?.AddSystemRole?.actionName, PER?.ScreenPermissions?.Insert) &&
            <Button
              size="large"
              variant="contained"
              onClick={() => handleClickOpen(1, "", "")}
              sx={{ textTransform: "capitalize", padding: "15px" }}
            >
              {t("Roles.addnew")}
            </Button>
          }
        </Box>

        <Box sx={{ backgroundColor: "#f8f9fa" }}>
          {getDetails?.length < 1 ? (
            <div hidden={spinner}>
              <Nodata />{" "}
            </div>
          ) : (
            getDetails?.map((r, i) => (
              <TableContainer component={Paper} className="mb-3" key={i}>
                <h4 className="mx-3 my-3" variant="contained">
                  {r?.organizationType}
                </h4>
                <Table aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>{t("Roles.rolesname")}</StyledTableCell>
                      <StyledTableCell>
                        {t("Roles.permissions")}{" "}
                      </StyledTableCell>
                      <StyledTableCell>
                        {r?.organizationType == "Admin" ? (
                          <>{t("Roles.rank")}</>
                        ) : r?.organizationType == "Client" ? (
                          "Organization"
                        ) : (
                          ""
                        )}
                      </StyledTableCell>
                      <StyledTableCell>&nbsp;</StyledTableCell>
                    </TableRow>
                  </TableHead>

                  <TableHead>
                    {r?.systemRoles?.map((q, i) => (
                      <TableRow key={i}>
                        <TableCell sx={{ width: "30%" }}>
                          {q?.roleName}
                        </TableCell>
                        <TableCell sx={{ width: "30%" }}>
                          <IconButton
                            aria-label="eye"
                            onClick={() => OpenTab(1, q)}
                          >
                            <img src={Eye} alt="eye" />
                          </IconButton>{" "}
                          <span sx={{ fontSize: "20px" }}>
                            View Permissions
                          </span>
                        </TableCell>
                        <TableCell sx={{ width: "30%" }}>
                          {q?.organizationType == "Super Client" ||
                            q?.organizationType == "Vendor" ? (
                            ""
                          ) : (
                            <div>
                              {q?.organizationType == "Client" ? (
                                <span
                                  onClick={() =>
                                    handleClickOpen(3, q?.roleId, q?.roleName)
                                  }
                                  style={{
                                    fontSize: "15px",
                                    color: "#2A93DB",
                                    cursor: "pointer",
                                  }}
                                >
                                  {"Select Org"}
                                </span>
                              ) : (
                                <div>
                                  <IconButton
                                    aria-label="edit"
                                    onClick={() =>
                                      handleClickOpen(2, q?.roleId, q?.orgRank)
                                    }
                                  >
                                    <img src={Edit} alt="editicon" />
                                  </IconButton>
                                  <span sx={{ fontSize: "20px" }}>
                                    {q?.orgRank}
                                  </span>
                                </div>
                              )}
                            </div>
                          )}
                        </TableCell>
                        <TableCell sx={{ width: "20%" }}>

                          {!HasScreenPermissions(INFO?.AddOrEditPermissions?.actionName) &&
                            <IconButton
                              aria-label="eye"
                              onClick={() => OpenTab(2, q)}
                            >
                              <img src={Edit} alt="Edit" />
                            </IconButton>
                          }
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableHead>
                </Table>
              </TableContainer>
            ))
          )}
        </Box>
      </div>
      <div style={{ display: shows ? "none" : "block" }}>
        <RolesAdminAccount
          OpenTab={OpenTab}
          SendDetails={MoveDetails}
          type={Type}
          Refresh={Trg}
        />
      </div>
    </>
  );
}
